var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5506_14538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20163 9.394C9.10787 9.30026 8.98071 9.24761 8.84813 9.24761C8.71555 9.24761 8.5884 9.30026 8.49463 9.394L6.67763 11.2095V1C6.67763 0.867392 6.62495 0.740215 6.53118 0.646447C6.43742 0.552678 6.31024 0.5 6.17763 0.5V0.5C6.04502 0.5 5.91785 0.552678 5.82408 0.646447C5.73031 0.740215 5.67763 0.867392 5.67763 1V11.204L3.86813 9.394C3.82252 9.34437 3.76734 9.30448 3.70592 9.27672C3.6445 9.24896 3.5781 9.23391 3.51071 9.23246C3.44332 9.23102 3.37634 9.24322 3.31378 9.26832C3.25123 9.29342 3.19439 9.33092 3.1467 9.37854C3.099 9.42617 3.06143 9.48295 3.03624 9.54547C3.01104 9.60799 2.99875 9.67496 3.0001 9.74235C3.00145 9.80974 3.01641 9.87616 3.04408 9.93762C3.07175 9.99909 3.11157 10.0543 3.16113 10.1L5.12063 12.0595C5.25992 12.1988 5.42529 12.3093 5.6073 12.3847C5.7893 12.4601 5.98438 12.4989 6.18138 12.4989C6.37839 12.4989 6.57346 12.4601 6.75547 12.3847C6.93747 12.3093 7.10284 12.1988 7.24213 12.0595L9.20163 10.1C9.29506 10.0063 9.34753 9.87934 9.34753 9.747C9.34753 9.61466 9.29506 9.48772 9.20163 9.394Z",
    fill: "#0090D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5506_14538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeta);
export default __webpack_public_path__ + "static/media/seta.8bd45cf8a1b0882e2fcd25b3abe776c5.svg";
export { ForwardRef as ReactComponent };